<ng-container *ngIf="!seletedGraphType">
  <app-select-linechart-type (selectedGraphType)="seletedGraphType = $event">
  </app-select-linechart-type>
</ng-container>

<ng-container *ngIf="seletedGraphType">
  <app-linechart-editor [graphType]="seletedGraphType" [data]="data"> </app-linechart-editor>
</ng-container>
